import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fab } from "@fortawesome/free-brands-svg-icons";
import {
  faHome,
  faTicket,
  faTasksAlt,
  faUser,
  faUsers,
  faInbox,
  faSearch,
  faFilter,
  faTrash,
  faUpload,
  faSliders,
  faAngleRight,
  faCaretUp,
  faCaretDown,
} from "@fortawesome/free-solid-svg-icons";
import reportWebVitals from "./reportWebVitals";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import "antd/dist/reset.css";
import "react-datepicker/dist/react-datepicker.css";
import "primeicons/primeicons.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import packageJSON from "../package.json";

window.SUPPORT_PORTAL_VERSION = packageJSON.version;
console.log(`Support Portal version: ${window.SUPPORT_PORTAL_VERSION}`);
console.log(
  `Environment variables loaded from: ${process.env.REACT_APP_ENV_FILE}`
);

const root = ReactDOM.createRoot(document.getElementById("root"));

library.add(
  fab,
  faHome,
  faTicket,
  faTasksAlt,
  faUser,
  faUsers,
  faUpload,
  faInbox,
  faSearch,
  faFilter,
  faTrash,
  faSliders,
  faAngleRight,
  faCaretUp,
  faCaretDown
);

root.render(<App />);

reportWebVitals();
